const dateToTimeStamp=(num)=>{
    return new Date(num).getTime() / 1000
}

const timestampToDate=(num)=>{
    let miliSec = num * 1000
    let dateObject = new Date(miliSec)
    return dateObject.toLocaleDateString()
}

const dateFormat=(num)=>{
    let miliSec = num * 1000
    var today = new Date(miliSec);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;
    return today
}

module.exports={
    dateToTimeStamp,
    timestampToDate,
    dateFormat
}